import { render, staticRenderFns } from "./app_03_decoration.vue?vue&type=template&id=4ec03cb0&lang=pug&"
import script from "./app_03_decoration.vue?vue&type=script&lang=js&"
export * from "./app_03_decoration.vue?vue&type=script&lang=js&"
import style0 from "./app_03_decoration.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports